<template>
  <div v-if="quesList && quesList.length" class="lv-ques-list-sort-by-risk">
    <div class="lv-ques-list-sort-by-risk__title-wrap mb-20">
      <LvText
        h3
        :color="risk.color"
        class="mr-4"
      ><i :class="risk.icon"/></LvText>
      <LvText h3> {{`${$t(risk.text)} ${$t('共{number}題',{number:quesList.length})}`}} </LvText>
    </div>
    <DataTable
      v-if="quesList && quesList.length"
      :columnHeader="columnHeader"
      :rowData="quesList"
      @click-icon="$_onClickIcon($event)"
      @data-click="$_onClickItem($event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    columnHeader: {
      type: Array,
    },
    quesList: {
      type: Array,
    },
    risk: {
      type: Object,
    },
  },
  methods: {
    $_onClickIcon($event) {
      this.$emit('click-icon', $event);
    },
    $_onClickItem($event) {
      this.$emit('click-item', $event);
    }
  }
}
</script>